import { lazy, Suspense } from 'react';

import LoadingFallback from 'routes/LoadingFallback';

const PublicRequest = lazy(() => import('pages/PublicRequest'));
const PublicSolvedTicket = lazy(() => import('pages/PublicSolvedTicket'));

/**
 * @module routes-public
 * Function to check if a given URL is a public route.
 *
 * @param {string} url - The URL to check
 * @returns {boolean} True if the URL is a public route, false otherwise.
 */
export const isPublic = (url: string): boolean =>
  ['/PublicRequest', '/PublicSolvedTicket'].includes(url);

/**
 * Object containing public routes with corresponding JSX elements.
 */
export const publicRoutes: { [key: string]: JSX.Element } = {
  '/PublicRequest': (
    <Suspense fallback={<LoadingFallback />}>
      <PublicRequest />
    </Suspense>
  ),
  '/PublicSolvedTicket': (
    <Suspense fallback={<LoadingFallback />}>
      <PublicSolvedTicket />
    </Suspense>
  )
};
